export default __webpack_public_path__ + "static/media/mp_privacy_policy.54501d91.svg";